import { CREDIT_CARD, PAYPAL_CHECKOUT } from '@constants/paymentMethods'
import {
  GetPaymentMethodResponse,
  METHOD_TYPE_CREDIT_CARD,
  METHOD_TYPE_PAYPAL,
  PaymentMethodType
} from '@services/payments/useGetPaymentMethod'

export const getPaymentMethod = (type?: PaymentMethodType) => {
  switch (type) {
    case METHOD_TYPE_CREDIT_CARD:
      return CREDIT_CARD
    case METHOD_TYPE_PAYPAL:
      return PAYPAL_CHECKOUT
    default:
      return CREDIT_CARD
  }
}

export const isCreditCardDataFilled = (
  paymentMethodsData: GetPaymentMethodResponse
) => {
  const { type, card_info } = paymentMethodsData

  return (
    type === METHOD_TYPE_CREDIT_CARD &&
    Boolean(card_info?.provider?.trim()) &&
    Boolean(card_info?.expiration_date?.trim()) &&
    Boolean(card_info?.last_two_digits?.trim())
  )
}

export const getFormattedExpirationDate = (date: string) => {
  const [month, year] = date.split('/')

  return `${month} / ${year.slice(-2)}`
}

export const getFormattedExtensionDate = ({
  date,
  language
}: {
  date: string
  language: string
}) =>
  new Intl.DateTimeFormat(language, {
    day: 'numeric',
    month: 'short',
    year: 'numeric'
  }).format(new Date(date))
